import { render, staticRenderFns } from "./description.component.html?vue&type=template&id=6ed1c823&scoped=true&"
import script from "./description.component.ts?vue&type=script&lang=ts&"
export * from "./description.component.ts?vue&type=script&lang=ts&"
import style0 from "./description.component.scss?vue&type=style&index=0&id=6ed1c823&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed1c823",
  null
  
)

export default component.exports